import { Backdrop } from 'components/ui/Backdrop/index.js';
import {
  type FC,
  useEffect,
} from 'react';
import { useMyUser } from 'shared/context/getMyUser.js';
import { useNavigateToDefaultPage } from 'shared/context/useNavigateToDefaultPage.js';

export const LoginSuccessPage: FC = () => {
  const { user } = useMyUser();
  const { navigateToDefaultPage } = useNavigateToDefaultPage({ user });

  useEffect(() => {
    void navigateToDefaultPage();
  }, [user]);

  return <Backdrop open />;
};
